/* BY · Be Yours — JavaScript propio del tema.
   Vanilla, sin librerías. Se carga con defer. */
(function () {
  'use strict';

  /* Animaciones de entrada al hacer scroll (un solo observer compartido) */
  function initReveals() {
    var elementos = document.querySelectorAll('.by-reveal');
    if (!elementos.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elementos.forEach(function (el) { el.classList.add('by-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('by-visible');
          observer.unobserve(entrada.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    elementos.forEach(function (el) { observer.observe(el); });
  }

  /* Galería de la página de producto */
  function initGaleria() {
    var galeria = document.querySelector('[data-by-galeria]');
    if (!galeria) return;
    var principal = galeria.querySelector('[data-by-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-by-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var nuevaSrc = mini.getAttribute('data-src');
        var nuevaSrcset = mini.getAttribute('data-srcset');
        var nuevaAlt = mini.getAttribute('data-alt') || '';
        if (!nuevaSrc || principal.getAttribute('src') === nuevaSrc) return;
        principal.classList.add('by-cambiando');
        setTimeout(function () {
          principal.setAttribute('src', nuevaSrc);
          if (nuevaSrcset) principal.setAttribute('srcset', nuevaSrcset);
          principal.setAttribute('alt', nuevaAlt);
          principal.classList.remove('by-cambiando');
        }, 180);
        minis.forEach(function (m) { m.classList.remove('by-activa'); });
        mini.classList.add('by-activa');
      });
    });
  }

  /* Selector de cantidad (+ / −) */
  function initCantidad() {
    document.querySelectorAll('[data-by-cantidad]').forEach(function (grupo) {
      var input = grupo.querySelector('input');
      var menos = grupo.querySelector('[data-by-menos]');
      var mas = grupo.querySelector('[data-by-mas]');
      if (!input || !menos || !mas) return;
      menos.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
      });
      mas.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });
    });
  }

  /* Selector de variantes: actualiza id, precio y disponibilidad */
  function initVariantes() {
    var formZona = document.querySelector('[data-by-compra]');
    if (!formZona) return;
    var datos = formZona.querySelector('[data-by-variantes-json]');
    var selects = formZona.querySelectorAll('[data-by-opcion]');
    if (!datos || !selects.length) return;
    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    var inputId = formZona.querySelector('input[name="id"]');
    var precioEl = formZona.querySelector('[data-by-precio]');
    var antesEl = formZona.querySelector('[data-by-precio-antes]');
    var boton = formZona.querySelector('[data-by-boton-comprar]');

    function formateaDinero(centavos) {
      return (centavos / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function alCambiar() {
      var elegidas = [];
      selects.forEach(function (s) { elegidas.push(s.value); });
      var variante = variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === elegidas[i]; });
      });
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formateaDinero(variante.price);
      if (antesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          antesEl.textContent = formateaDinero(variante.compare_at_price);
          antesEl.hidden = false;
        } else {
          antesEl.hidden = true;
        }
      }
      if (boton) {
        boton.disabled = !variante.available;
        var textoNormal = boton.getAttribute('data-texto-normal') || 'Añadir al carrito';
        var textoAgotado = boton.getAttribute('data-texto-agotado') || 'Agotado';
        var etiqueta = boton.querySelector('[data-by-boton-texto]');
        if (etiqueta) etiqueta.textContent = variante.available ? textoNormal : textoAgotado;
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', alCambiar); });
  }

  /* Calculadora de cajas para mudanza */
  function initCalculadora() {
    var raiz = document.querySelector('[data-by-calc]');
    if (!raiz) return;
    var datosEl = document.querySelector('[data-by-calc-catalogo]');
    if (!datosEl) return;
    var cat;
    try { cat = JSON.parse(datosEl.textContent); } catch (e) { return; }

    // Cajas base por vivienda para 2 personas y nivel normal: [medianas, pequeñas]
    // Calibrado sobre pedidos reales: el grueso de una mudanza son cajas medianas.
    var BASE = {
      estudio: [9, 5],
      piso1: [12, 7],
      piso2: [18, 10],
      piso3: [24, 13],
      casa: [32, 17]
    };
    // Cajas grandes 60x40x40 si elige mudar el textil en cajas grandes
    var GRANDES = { estudio: 6, piso1: 8, piso2: 10, piso3: 11, casa: 16 };
    // Bolsas XXL si elige mudar el textil en bolsas
    var BOLSAS = { estudio: 2, piso1: 3, piso2: 4, piso3: 6, casa: 8 };
    // Explicación de cada forma de mudar el textil
    var PISTAS = {
      grandes: 'Edredones, nórdicos y almohadas abultan pero pesan poco: van en las de 60×40×40 y te liberan cajas medianas.',
      bolsas: 'Las bolsas XXL se cargan a la espalda, ocupan menos que una caja y después se guardan dobladas.',
      cajas: 'Todo el textil repartido en cajas medianas. Es lo más barato, pero llenarás bastantes más cajas.'
    };
    // Extras: [medianas, pequeñas]
    var EXTRAS = {
      despacho: [0, 5],
      trastero: [4, 2],
      libros: [0, 6]
    };

    var vivienda = raiz.querySelector('[data-by-calc-vivienda]');
    var personas = raiz.querySelector('[data-by-calc-personas]');
    var nivel = raiz.querySelector('[data-by-calc-nivel]');
    var ropa = raiz.querySelector('[data-by-calc-ropa]');
    var pista = raiz.querySelector('[data-by-calc-pista]');
    var extras = raiz.querySelectorAll('[data-by-calc-extra]');
    var salidaNec = raiz.querySelector('[data-by-calc-necesitas]');
    var salidaPacks = raiz.querySelector('[data-by-calc-packs]');
    var salidaTotal = raiz.querySelector('[data-by-calc-total]');
    var avisoAhorro = raiz.querySelector('[data-by-calc-ahorro]');
    var avisoCinta = raiz.querySelector('[data-by-calc-cinta-incluida]');
    var botonCarrito = raiz.querySelector('[data-by-calc-carrito]');

    function euros(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

    // Elige la combinación de packs más barata que cubra al menos el 90% de lo necesario.
    // Ese margen evita empujar un pack entero de más por una o dos cajas de diferencia.
    function mejorCombo(n, hay20, hay10, precio20, precio10) {
      if (n <= 0) return { c20: 0, c10: 0, coste: 0, unidades: 0 };
      var minimo = Math.max(1, Math.round(n * 0.9));
      var mejor = null;
      for (var a = 0; a <= Math.ceil(n / 20) + 1; a++) {
        if (!hay20 && a > 0) break;
        for (var b = 0; b <= Math.ceil(n / 10) + 1; b++) {
          if (!hay10 && b > 0) break;
          var unidades = a * 20 + b * 10;
          if (unidades < minimo) continue;
          var coste = a * precio20 + b * precio10;
          if (!mejor || coste < mejor.coste - 0.001) mejor = { c20: a, c10: b, coste: coste, unidades: unidades };
        }
      }
      return mejor || { c20: 0, c10: 0, coste: 0, unidades: 0 };
    }

    function marcado(nombre) {
      var el = raiz.querySelector('[data-by-calc-extra="' + nombre + '"]');
      return el && el.checked;
    }

    function calcular() {
      var v = vivienda.value;
      var base = BASE[v] || BASE.piso2;
      var med = base[0], peq = base[1];

      var fPersonas = Math.max(0.6, 1 + (parseInt(personas.value, 10) - 2) * 0.10);
      var fNivel = parseFloat(nivel.value);
      // Tope al factor combinado: sin él, "muchas cosas" + "5 personas" dispara el resultado
      var f = Math.min(1.45, fPersonas * fNivel);

      // El textil va a cajas grandes, a bolsas XXL o repartido en medianas.
      // Cada opción es excluyente: sacar el textil de las medianas reduce cuántas hacen falta.
      var modo = ropa.value;
      if (modo !== 'grandes' && modo !== 'bolsas') modo = 'cajas';
      med = med * (modo === 'cajas' ? 1.15 : modo === 'bolsas' ? 0.88 : 0.92);

      med = Math.ceil(med * f);
      peq = Math.ceil(peq * f);

      // Los extras son cantidades concretas: se suman DESPUÉS, sin multiplicar
      Object.keys(EXTRAS).forEach(function (k) {
        if (marcado(k)) { med += EXTRAS[k][0]; peq += EXTRAS[k][1]; }
      });
      var gra = modo === 'grandes' ? Math.ceil((GRANDES[v] || 8) * fNivel) : 0;
      var bolsasUd = modo === 'bolsas' ? Math.ceil((BOLSAS[v] || 4) * fPersonas) : 0;

      // Packs (solo de lo que realmente hace falta)
      var cMed = mejorCombo(med, cat.med20, cat.med10, parseFloat(cat.med20p), parseFloat(cat.med10p));
      var cPeq = mejorCombo(peq, cat.peq20, cat.peq10, parseFloat(cat.peq20p), parseFloat(cat.peq10p));
      // Las grandes solo se venden en pack de 10: se redondea al pack más cercano.
      // Hacia arriba siempre encarecería 33 € por una sola caja de diferencia.
      var nGra = gra > 0 && cat.gra10 ? Math.max(1, Math.round(gra / 10)) : 0;
      var nBolsas = bolsasUd > 0 && cat.bolsas ? Math.ceil(bolsasUd / 4) : 0;

      if (pista) pista.textContent = PISTAS[modo] || '';

      // Unidades que realmente recibe
      var udMed = cMed.unidades, udPeq = cPeq.unidades, udGra = nGra * 10, udBolsas = nBolsas * 4;
      var totalCajas = udMed + udPeq + udGra;
      var rollosGratis = cMed.c20 + cMed.c10 + cPeq.c20 + cPeq.c10 + nGra;
      // El pack de 36 rollos es industrial: NUNCA se añade solo a una mudanza doméstica.
      // Solo entra si el usuario lo pide expresamente con la casilla.
      var nCinta = (cat.cinta && marcado('cinta')) ? 1 : 0;

      // ---- Lo que recibe ----
      salidaNec.innerHTML =
        fila(udMed, cat.nombres.med, med) +
        fila(udPeq, cat.nombres.peq, peq) +
        fila(udGra, cat.nombres.gra, gra) +
        fila(udBolsas, cat.nombres.bolsas, bolsasUd) +
        fila(rollosGratis + (nCinta ? 36 : 0), cat.nombres.cinta, 0) +
        (nCinta ? '' : '<p class="by-calc__ahorro">Los ' + rollosGratis + ' rollos van incluidos de regalo con tus packs, sin coste.</p>');

      // ---- Packs ----
      var lineas = [], carrito = [], total = 0;
      function add(cant, varId, precio, texto, url) {
        if (!cant || !varId) return;
        var sub = cant * precio;
        total += sub;
        lineas.push('<li><span>' + cant + ' × <a href="' + url + '">' + texto + '</a></span><b>' + euros(sub) + '</b></li>');
        carrito.push(varId + ':' + cant);
      }
      add(cMed.c20, cat.med20, parseFloat(cat.med20p), 'Pack 20 cajas medianas', cat.urls.med20);
      add(cMed.c10, cat.med10, parseFloat(cat.med10p), 'Pack 10 cajas medianas', cat.urls.med10);
      add(cPeq.c20, cat.peq20, parseFloat(cat.peq20p), 'Pack 20 cajas pequeñas', cat.urls.peq20);
      add(cPeq.c10, cat.peq10, parseFloat(cat.peq10p), 'Pack 10 cajas pequeñas', cat.urls.peq10);
      add(nGra, cat.gra10, parseFloat(cat.gra10p), 'Pack 10 cajas grandes', cat.urls.gra10);
      add(nBolsas, cat.bolsas, parseFloat(cat.bolsasp), 'Pack 4 bolsas XXL', cat.urls.bolsas);
      add(nCinta, cat.cinta, parseFloat(cat.cintap), 'Pack 36 rollos de cinta', cat.urls.cinta);

      salidaPacks.innerHTML = lineas.join('');
      salidaTotal.textContent = euros(total);
      if (avisoAhorro) avisoAhorro.hidden = lineas.length < 2;
      if (avisoCinta) avisoCinta.hidden = nCinta !== 0;
      botonCarrito.setAttribute('href', carrito.length ? '/cart/' + carrito.join(',') : '#');
      botonCarrito.classList.toggle('by-btn--desactivado', !carrito.length);
    }

    // Muestra las unidades que recibe y, si el pack da de más, lo dice con transparencia
    function fila(unidades, texto, necesarias) {
      if (!unidades) return '';
      var extra = '';
      if (necesarias && unidades > necesarias) {
        extra = '<em class="by-calc__sobran">calculamos ' + necesarias + ', te sobran ' + (unidades - necesarias) + '</em>';
      } else if (necesarias && unidades < necesarias) {
        extra = '<em class="by-calc__sobran">calculamos ' + necesarias + ': el siguiente pack se te quedaría muy largo</em>';
      }
      return '<div class="by-calc__linea"><span class="by-calc__cant">' + unidades + '</span><span>' + texto + extra + '</span></div>';
    }

    [vivienda, personas, nivel, ropa].forEach(function (el) { if (el) el.addEventListener('change', calcular); });
    extras.forEach(function (e) { e.addEventListener('change', calcular); });
    calcular();
  }

  function initTodo() {
    initReveals();
    initGaleria();
    initCantidad();
    initVariantes();
    initCalculadora();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
})();

/* Descripcion de coleccion: "leer mas" en movil (ronda 69, 28/08/2026).
   El boton nace con [hidden] y solo se activa si de verdad hay texto recortado,
   asi no aparece un "leer mas" que no despliega nada. */
(function () {
  var desc = document.getElementById('by-desc-coleccion');
  var btn = desc && desc.parentNode.querySelector('.by-leer-mas');
  if (!desc || !btn) return;

  function hayCorte() {
    return window.matchMedia('(max-width: 749px)').matches
      && !desc.classList.contains('by-abierta')
      && desc.scrollHeight > desc.clientHeight + 4;
  }
  function revisar() {
    if (desc.classList.contains('by-abierta')) { btn.hidden = false; return; }
    btn.hidden = !hayCorte();
  }

  btn.addEventListener('click', function () {
    var abierta = desc.classList.toggle('by-abierta');
    btn.setAttribute('aria-expanded', abierta ? 'true' : 'false');
    btn.textContent = abierta ? btn.dataset.menos : btn.dataset.mas;
  });

  revisar();
  window.addEventListener('resize', revisar, { passive: true });
})();
